import { Flag } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "../client-Details-Style.css";
import "./multimobile.css";
import { getIcon } from "utils/iconsConfig";

function MultiMobile({ phoneNumber, setPhoneNumber, updateSession, Field, email, setEmail, errors, setErrors }) {

  const isValidEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  
  const isValidPhone = (value) =>
    /^[0-9]{10}$/.test(value);

  const handlePhoneChange = (value, index) => {
    const cleaned = value.replace(/\D/g, "").replace(/^91/, "");
    const tenDigitNumber = cleaned.slice(0, 10);
    const updated = [...phoneNumber];
    updated[index] = tenDigitNumber ? `91${tenDigitNumber}` : "";

    setPhoneNumber(updated);

    setErrors((prev) => {
      const updatedPhoneErrors = [...(prev.phoneNumber || [])];
      // if (!cleaned) {
      //   updatedPhoneErrors[index] = "Mobile number is required";
      // } else if (!isValidPhone(cleaned)) {
      //   updatedPhoneErrors[index] = "Enter 10 digit mobile number";
      // } else {
      //   updatedPhoneErrors[index] = "";
      // }
      updatedPhoneErrors[index] = "";
      return {
        ...prev,
        phoneNumber: updatedPhoneErrors,
      };
    });

    updateSession("phoneNumbers", updated);
  };

  const handleAddDelete = (type, index, target) => {
    let updated = target === "phone" ? [...phoneNumber] : [...email];

    if (type === "ADD") {
      updated.push("");
    } else if (type === "DELETE") {
      updated.splice(index, 1);
    }

    if (target === "phone") {
      setPhoneNumber(updated);
      updateSession("phoneNumbers", updated);
    } else {
      setEmail(updated);
      updateSession("emails", updated);
    }
  };

  const handleClear = (index, target) => {
    let updated = target === "phone" ? [...phoneNumber] : [...email];
    updated[index] = "";

    if (target === "phone") {
      setPhoneNumber(updated);
      updateSession("phoneNumbers", updated);
    } else {
      setEmail(updated);
      updateSession("emails", updated);
    }
  };

  const handleEmailChange = (value, index) => {
    const updated = [...email];
    updated[index] = value === "" ? "" : value;

    setEmail(updated);
    updateSession("emails", updated);

    setErrors((prev) => {
      const updatedEmailErrors = [...(prev.email || [])];
      updatedEmailErrors[index] = "";
      // if (!value.trim()) {
      //   updatedEmailErrors[index] = "Email is required";
      // } else if (!isValidEmail(value)) {
      //   updatedEmailErrors[index] = "Enter a valid email address";
      // } else {
      //   updatedEmailErrors[index] = "";
      // }
      return {
        ...prev,
        email: updatedEmailErrors,
      };
    });
  };

  return (
    <Box className="Field">
      <label className="Field-label">{Field === "Email" ? "Email" : "Mobile No."}</label>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5vw" }}>
        {Field === "Email"
          ? (email?.length > 0 ? email : [""])?.map((email, index) => (
              <div>
                <Box key={index} display="flex" alignItems="center" gap="0.9vw" flexWrap="wrap" marginBottom=".25vw">
                  <Box flex="1">
                    <div>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          borderRadius: "8px",
                          border: errors?.email?.[index] ? "1px solid #F23D3D" : "",
                          background: errors?.email?.[index] ? "#F23D3D08" : "transparent",
                        }}
                        className="Field-input"
                      >
                        <input
                          type="email"
                          value={email}
                          placeholder="Enter email"
                          onChange={(e) => handleEmailChange(e.target.value, index)}
                          style={{
                            width: "100%",
                            backgroundColor: "transparent",
                            color: "white",
                            height: "2.5vw",
                            fontSize: "0.9vw",
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            textAlign: "start",
                            outline: "none",
                            border: "none",
                          }}
                        />

                        {email && email.length > 0 && (
                          <span
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "95%",
                              transform: "translateY(-50%)",
                              padding: ".25vw",
                              background: "transparent !important",
                              color: "#595959",
                              fontSize: ".9vw",
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClear(index, "email")}
                          >
                            X
                          </span>
                        )}
                      </div>
                    </div>
                  </Box>

                  <Box>
                    {index === 0 ? (
                      <button className="add-btn" onClick={() => handleAddDelete("ADD", index, "email")}>
                        +
                      </button>
                    ) : (
                      <button
                        className="delete-btn"
                        style={{
                          pointerEvents: "auto",
                        }}
                        onClick={() => handleAddDelete("DELETE", index, "email")}
                      >
                        {getIcon("DustbinIcon")}
                      </button>
                    )}
                  </Box>
                </Box>

                {email.length > 0 && <span className="errorline">{errors?.email?.length > 0 && errors?.email[index]}</span>}
              </div>
            ))
          : (phoneNumber?.length > 0 ? phoneNumber : [""])?.map((phone, index) => (
              <div>
                <Box key={index} display="flex" alignItems="center" gap=".9vw" flexWrap="wrap" marginBottom=".25vw">
                  <Box flex="1">
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        borderRadius: "8px",
                        border: errors?.phoneNumber?.[index] ? "1px solid #F23D3D" : "",
                        background: errors?.phoneNumber?.[index] ? "#F23D3D08" : "transparent",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5vw",
                      }}
                      className="Field-input"
                    >
                      {getIcon("Flag")}
                      {
                        <span
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "0.85vw",
                            color: "#fff",
                            marginRight: "0.4vw",
                          }}
                        >
                          +91
                        </span>
                      }
                      {<span style={{ fontSize: "0.5vw", color: "#333333", transform: "translateY(1px)" }}>▼</span>}
                      <span
                        style={{
                          height: "1.2vw",
                          width: "1px",
                          background: "#333333",
                          marginLeft: "0.6vw",
                          marginRight: "0.6vw",
                        }}
                      />
                      <input
                        type="text"
                        value={phone?.startsWith("91") ? phone.slice(2) : phone}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/\D/g, "");
                          handlePhoneChange(numericValue, index);
                        }}
                        placeholder="Enter mobile number"
                        maxLength={10}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          fontFamily: "Poppins",
                          fontSize: "0.85vw",
                          color: "#fff",
                        }}
                      />

                      {phone && phone.length > 2 && (
                        <span style={{ color: "#595959", transform: "translateY(1px)", cursor: "pointer" }} onClick={() => handleClear(index, "phone")}>
                          X
                        </span>
                      )}
                    </div>
                  </Box>

                  <Box display={index === 0 && phone.length === 2 ? "none" : "block"}>
                    {index === 0 ? (
                      <button className="add-btn" onClick={() => handleAddDelete("ADD", index, "phone")}>
                        +
                      </button>
                    ) : (
                      <button
                        className="delete-btn"
                        style={{
                          pointerEvents: "auto",
                        }}
                        onClick={() => handleAddDelete("DELETE", index, "phone")}
                      >
                        {getIcon("DustbinIcon")}
                      </button>
                    )}
                  </Box>
                </Box>
                {phone.length > 0 && <span className="errorline"> {errors?.phoneNumber?.length > 0 && errors?.phoneNumber[index]}</span>}
              </div>
            ))}
      </Box>
    </Box>
  );
}

export default MultiMobile;
